// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Eub7k","text":"styles_text__Ht4ye","icon":"styles_icon__ajRCA"};